<template>
    <div :class="showmode">
        <div class="select">
            <loader :flag="loadingInformation"></loader>
            <h3 v-lang.metodosPago  v-if="!loading && !loadingInformation"></h3>
            <div v-for="card in cardsInformation" v-bind:key="card.token" v-if="!loading && !loadingInformation">
                <div class="media">
                    <div class="media-left">
                        <input type="radio" :id="'pm_' + card.token" :value="card.token" v-model="pmDefault" @click="onDefaultChange(card)">
                    </div>
                    <div class="media-left">
                        <img class="media-object" :src="card.imageUrl" alt="">
                    </div>
                    <div class="media-body">
                        <div v-if="card.type === 'card'">
                            <strong>{{ card.cardType }} {{ translate('terminadaEn') }} {{ card.last4 }} {{ translate('expiraEl') }} {{ card.expirationDate }}</strong>

                        </div>
                        <div v-else>
                            <strong>Paypal - {{ card.email }}</strong>
                        </div>
                    </div>
                    <div class="media-right">
                        <svg-item @click.native="onDelete(card)" :size="18" :icon="'cerrar'"></svg-item>
                    </div>
                </div>
            </div>
            <div v-if="cardsInformation.length === 0 && !loading && !loadingInformation" class="text-danger" v-lang.noHayMetodos>
                No hay métodos de pagos
            </div>
            <h3 v-lang.agregar class="add">Agregar</h3>
            <form id="add-card-form" v-if="paymentezLoaded">
                <div class="paymentez-form" id="form-paymentez" data-capture-name="false"></div>
                <button class="btn btn-add-method" v-lang.agregarMedioPago>Save</button>
            </form>
            <div v-if="instance">
                <button class="btn btn-secondary" v-if="showbutton" @click="onSubmit" v-lang.agregarMedioPago></button>
            </div>
        </div>
        <div class="payment-data">
            <loader :flag="loadingInformation"></loader>
            <div>
                <div class="media" v-if="defaultPayment">
                    <div class="media-left">
                        <img class="media-object" :src="defaultPayment.imageUrl" alt="">
                    </div>
                    <div class="media-body">
                        <div v-if="defaultPayment.type === 'card'">
                            <strong>{{ defaultPayment.cardType }} {{ this.translate('terminadaEn') }} {{ defaultPayment.last4 }} {{ this.translate('expiraEl') }} {{ defaultPayment.expirationDate }}</strong>
                        </div>
                        <div v-else>
                            <strong>Paypal - {{ defaultPayment.email }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apis } from '../../services/api';
import dialogs from '@/services/dialogs';
let paymentsApi = apis.paymentsApi;
export default {
    name: 'paymentez-profile',
    props: {
        'paymentmethod': {
            type: Object,
            required: false,
            default: null
        },
        'pmconfig': {
            type: Object,
            required: false,
            default: null
        },
        'showbutton': {
            type: Boolean,
            required: false,
            default: true
        },
        'showmode': {
            type: String,
            required: false,
            default: 'default'
        },
        'user': {
            type: Object,
            required: false,
            default: null
        }
    },
    data () {
        return {
            instance: null,
            paymentMethodConfigurationId: 0,
            loading: true,
            loadingInformation: true,
            cardsInformation: [],
            paymentezLoaded: false,
            pmDefault: 0
        };
    },
    mounted () {
        this.language = this.$getLang();

        console.log('mounted Paymentez profile', this.pmconfig);
        if (this.pmconfig) {
            console.log('mounted Paymentez with config', this.pmconfig);
            let data = {
                payment_method_data_id: this.pmconfig.id,
                payment_method_id: this.paymentmethod.id
            };
            paymentsApi.information(data).then((result) => {
                console.log('informacion ', result);
                this.loadingInformation = false;
                this.cardsInformation = result.paymentMethods;

                if (this.pmconfig && this.pmconfig.config && this.pmconfig.config.default) {
                    console.log('default is', this.pmconfig.config.default);
                    this.pmDefault = this.pmconfig.config.default;
                } else {
                    if (this.cardsInformation && this.cardsInformation.length) {
                        this.pmDefault = this.cardsInformation[0].token;
                    }
                }
            });
        }
        if (this.showmode !== 'payment') {
            console.log('mounted Braintree profile no customerId', this.paymentmethod.options);
            // this.init(this.paymentmethod.options.env.clientKey);
            let paymentezCss = document.createElement('link');
            paymentezCss.type = 'text/css';
            paymentezCss.rel = 'stylesheet';
            paymentezCss.href = 'https://cdn.paymentez.com/js/1.0.1/paymentez.min.css';
            document.head.appendChild(paymentezCss);
            let jqueryScript = document.createElement('script');
            document.head.appendChild(jqueryScript);
            jqueryScript.onload = () => {
                console.log('on load jquery');
                let paymentezScript = document.createElement('script');
                document.head.appendChild(paymentezScript);
                paymentezScript.onload = () => {
                    console.log('on load paymentez', this.paymentmethod.options);
                    this.paymentezLoaded = true;
                    this.loading = false;
                    this.$nextTick(function () {
                        console.log('$nextTick', window.Paymentez);
                        this.init(this.paymentmethod.options.env);
                    });
                };
                paymentezScript.setAttribute('src', 'https://cdn.paymentez.com/js/1.0.1/paymentez.min.js');
            };
            jqueryScript.setAttribute('src', 'https://code.jquery.com/jquery-1.11.3.min.js');
        } else {
        }
    },
    computed: {
        defaultPayment () {
            console.log('this.cardsInformation', this.cardsInformation);
            let card = null;
            if (this.cardsInformation && this.cardsInformation.length) {
                if (this.pmconfig && this.pmconfig.config && this.pmconfig.config.default) {
                    card = this.cardsInformation.find(c => c.token === this.pmconfig.config.default);
                } else {
                    card = this.cardsInformation[0];
                }
            }
            console.log('default payment', card);
            return card;
        }
    },
    methods: {
        onSubmit (saveConfig = true) {
            return new Promise((resolve, reject) => {
                console.log('onSubmit', this.defaultPayment);
                let paymentInfo = {
                    token: this.defaultPayment.token
                };
                this.$emit('success', paymentInfo);
                resolve(paymentInfo);
            });
        },
        init (config) {
            window.Paymentez.init(config.env_mode, config.paymentez_client_app_code, config.paymentez_client_app_key);
            /* global $ */
            var formCard = $('#form-paymentez').PaymentezForm();
            // window.PaymentezForm(document.querySelector('#form-paymentez'));
            $('#add-card-form').submit((e) => {
                this.loadingInformation = true;
                e.preventDefault();
                // var formCard = $('#form-paymentez');
                var cardToSave = formCard.PaymentezForm('card');
                console.log('cardToSave', cardToSave);
                if (cardToSave == null) {
                    // $('#messages').text("Invalid Card Data");
                } else {
                    console.log('this.user', this.user);
                    cardToSave.card.holder_name = this.user.nombre + ' ' + this.user.apellido;
                    let uid = '' + this.user.id;
                    let email = this.user.email;
                    window.Paymentez.addCard(uid, email, cardToSave, (cardResponse) => {
                        console.log(cardResponse.card);
                        let data = {
                            payment_method_data_id: this.paymentMethodConfigurationId,
                            payment_method_id: this.paymentmethod.id,
                            config: {
                                customerId: '' + this.user.id
                            },
                            nonce: cardResponse.card.token
                        };
                        paymentsApi.config(data).then((result) => {
                            this.loadingInformation = false;
                            console.log('configurar id', result);
                            this.paymentMethodConfigurationId = result.id;
                            this.$emit('success', result);
                        }).catch((error) => {
                            console.log('catrch', error);
                            this.$emit('success', null);
                        });
                    }, (err) => {
                        console.log('catrch', err.error);
                        if (err.error.type.indexOf('Card already added') >= 0) {
                            this.$emit('success', null);
                        } else {
                            dialogs.message(err.error.type + ' ' + err.error.help, { duration: 10, estado: 'error' });
                        }
                    });
                }

                e.preventDefault();
            });
        },
        onDelete (card) {
            console.log('onDelete', card, this.pmconfig);
            this.loadingInformation = true;
            let data = {
                payment_method_data_id: this.pmconfig.id,
                payment_method_id: this.paymentmethod.id,
                payment_method_info: card.token
            };
            paymentsApi.remove(data).then((result) => {
                this.loadingInformation = false;
                console.log('then remove', result);
                this.cardsInformation = this.cardsInformation.filter(c => c.token !== card.token);
                dialogs.message(this.translate('successMethodDelete'), { duration: 10, estado: 'success' });
            }).catch((error) => {
                console.log('catch remove', error);
                this.loadingInformation = false;
                dialogs.message(this.translate('errorMethodDelete'), { duration: 10, estado: 'error' });
            });
        },
        onDefaultChange (card) {
            this.loadingInformation = true;
            console.log('onDefaultChange', card, this.pmconfig);
            let data = {
                payment_method_data_id: this.pmconfig.id,
                payment_method_id: this.paymentmethod.id,
                payment_method_info: card.token
            };
            paymentsApi.setAsDefault(data).then((result) => {
                this.loadingInformation = false;
                dialogs.message(this.translate('successMethodDefault'), { duration: 10, estado: 'success' });
                console.log('then setAsDefault', result);
            }).catch((error) => {
                console.log('catch setAsDefault', error);
                this.loadingInformation = false;
                dialogs.message(this.translate('errorMethodDefault'), { duration: 10, estado: 'error' });
            });
        }
    }
};
</script>

<style scoped>
    .select {
        margin: -20px;
    }
    .payment .payment-data,
    .default .select {
        display: block;
    }
    .payment .select,
    .default .payment-data {
        display: none;
    }
    .media-left, .media-body {
        vertical-align: middle;
    }
    .loading-container {
        text-align: center;
    }
    .payment .payment-data {
        margin-top: .65em;
    }
    .btn-add-method {
        background-color: var(--primary-button-bg-color);
        color: var(--primary-button-fg-color);
    }
    h3 {
        margin-top: 0;
        color: var(--text-color);
    }
    h3.add {
        margin-top: .5em;
    }
    .select .media {
        margin-top: 1em;
        border-bottom: 1px solid #CCC;
        margin-bottom: 1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/components/PaymentezPayment.vue